import {
  Card,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Text,
} from "@clipboard-health/ui-components";
import { CardContent } from "@mui/material";

import { getTbTestChecklist } from "../constants";
import { type TbTestType } from "../types";

interface TbTestChecklistProps {
  testType?: TbTestType;
}

export function TbTestChecklist(props: TbTestChecklistProps) {
  const { testType } = props;
  const items = getTbTestChecklist(testType);

  return (
    <Card variant="tertiary">
      <CardContent>
        <List disablePadding>
          {items.map((item) => (
            <ListItem key={item} sx={{ paddingY: 1 }}>
              <ListItemIcon iconType="checkmark" />
              <ListItemText primary={<Text variant="body2">{item}</Text>} />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}
